import { getParent, types } from 'mobx-state-tree';
import { createThunk, ListModel, model } from 'mst-collection';

import { Api, schemas } from '@api';
import { TagModel } from './TagModel';
import type { Tutorial } from '../Tutorials/TutorialModel';

export class TutorialTagsList extends ListModel(
  types.reference(TagModel),
  {
    idAttribute: 'id',
    schema: schemas.TagsListSchema,
  },
) {
  get ids() {
    return this.array.map((t) => t.id);
  }

  get names() {
    return this.array.map((t) => t.name);
  }

  private get _parentId(): number {
    return getParent<Tutorial>(this, 1).id;
  }

  fetch = createThunk(() => {
    return async function fetch(this: TutorialTagsList) {
      const res = await Api.Hub.getTagsByTutorialId({
        id: this._parentId,
      });

      this.set(res.data.tags);
    };
  });
}

export const TutorialTagsListModel = model(TutorialTagsList);
